<template>
    <div style="padding: 4px 0">
        <v-card class="card-main">
        <v-card-text class="d-flex-row gap-12" style="justify-content: space-between; align-items: center">
            <div>
                <v-icon style="color: #0dc301; margin-right: 12px" v-if="data['status'] === 'UNREAD'">mdi-alert-circle-outline</v-icon>
                <v-icon style="margin-right: 12px" v-else>mdi-alert-circle-outline</v-icon>
                Сообщение
            </div>
            <v-btn icon @click="show = !show" >
                <v-icon color="grey" v-if="show">mdi-chevron-up</v-icon>
                <v-icon color="grey" v-else>mdi-chevron-down</v-icon>
            </v-btn>
        </v-card-text>
        <v-expand-transition>
            <div v-show="show">
                <v-divider/>
                <div class="d-flex-column gap-8" style="font-size: 14px">
                    <div style="font-weight: bold"
                         v-html="data['createdAt'].split(' ')[0] + ' | ' + data['createdAt'].split(' ')[1]"/>
                    <div v-html="data['content'].replaceAll('\n', '<br>')"/>
                </div>
                <v-divider v-show="data['status'] === 'UNREAD'"/>
                <div class="d-flex-row" style="justify-content: center" v-show="data['status'] === 'UNREAD'">
                    <div class="btn-read" @click="updateNotification(data['id'])">Отметить как прочитанное</div>
                </div>
            </div>
        </v-expand-transition>
    </v-card>
    </div>

</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    updateNotification (id) {
      this.show = false
      this.$emit('update', id)
    }
  }
}
</script>

<style  lang="scss" scoped>
.card-main{
    max-width: 500px;
}
.btn-read{
    color: #2F80ED; font-size: 13px;
    cursor: pointer;
    padding: 4px 12px;
    border-radius: 3px;
}
.btn-read:hover{
    background: rgba(47, 128, 237, 0.22);
}
.btn-read:active{
    background: rgba(47, 128, 237, 0.29);
}
.d-flex-row{
    display: flex;
    flex-direction: row;
    padding: 15px;
}
.d-flex-column{
    display: flex;
    flex-direction: column;
    padding: 15px;
}
.gap-12{
    gap: 12px;
}
.gap-8{
    gap: 8px;
}
@media screen and (max-width: 768px) {
    .card-main{
        max-width: none;
    }
}

</style>
